import { ActionContext } from "vuex/types";
import {
  getProcessHistory,
  getPublicHistory
} from "@/services/api/process/ApiProcess";
import { IProcessHistory, ITimeline } from "@/store/types/timeline";
import { ResponseType } from "@/store/types/types";
import { RootState } from "@/store/types/root";

const state = {
  timeLineItens: [] as IProcessHistory[],
  totalProcessTime: 0,
  status: "" as string,
  externalAbbreviation: "" as string | undefined
};

type State = typeof state;

const mutations = {
  setRequestSuccessStatus: (state: State, data: ITimeline) => {
    state.timeLineItens = data.history;
    state.totalProcessTime = data.total_process_time;
    state.externalAbbreviation = data.external_system_abbreviation;
    state.status = "success";
  },

  setRequestErrorStatus: (state: State) => {
    state.status = "error";
  }
};

const actions = {
  timeLineItensRequest: async (
    { commit }: ActionContext<State, RootState>,
    processId: string
  ) => {
    const results: ResponseType<ITimeline> = await getProcessHistory(processId);

    if (results.kind === "ok") commit("setRequestSuccessStatus", results.data);
    else commit("setRequestErrorStatus");
  },

  publicTimeLine: async (
    { commit, dispatch }: ActionContext<State, RootState>,
    processId: string
  ) => {
    const results: ResponseType<ITimeline> = await getPublicHistory(processId);

    if (results.kind === "ok" && results.data) {
      commit("setRequestSuccessStatus", results.data);
      dispatch("checkProcessHistory", processId);
    } else commit("setRequestErrorStatus");
  }
};

const getters = {
  getTimeLineItens: (state: State) => state.timeLineItens,
  getProcessTime: (state: State) => state.totalProcessTime,
  getExternalAbbreviation: (state: State) => state.externalAbbreviation
};

export default {
  state,
  mutations,
  actions,
  getters
};
